export default "__VITE_ASSET__Kqj$nReh__"